var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgReject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-reject_svg__cls-2{fill:none;stroke:#bc204b;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reject_svg__ICN_Respinge_Enabled",
    transform: "translate(-187 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reject_svg__Path_972",
    "data-name": "Path 972",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0A8.5 8.5 0 110 8.5 8.5 8.5 0 018.5 0z",
    transform: "translate(187 260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.6a6.908 6.908 0 00-6.9 6.9c0 3.805 3.095 6.9 6.9 6.9s6.9-3.095 6.9-6.9-3.095-6.9-6.9-6.9m0-1.6a8.5 8.5 0 110 17 8.5 8.5 0 010-17z",
    transform: "translate(187 260)",
    fill: "#bc204b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reject_svg__ICN_Inchide_Sertar_Detalii_Enabled",
    "data-name": "ICN_Inchide Sertar Detalii_Enabled",
    transform: "translate(-1549.5 6.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-reject_svg__Line_276",
    d: "M0 0l7.245 7.245",
    className: "kpmg-reject_svg__cls-2",
    "data-name": "Line 276",
    transform: "translate(1741.5 258.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-reject_svg__Line_277",
    d: "M0 7.245L7.245 0",
    className: "kpmg-reject_svg__cls-2",
    "data-name": "Line 277",
    transform: "translate(1741.5 258.634)"
  })))));
}

export default SvgKpmgReject;